// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1088be15","455":"8a4cb49f"}[chunkId] + ".chunk.js";
};